<template>
  <div class="app-change-password-wrapper">
    <slot name="txtBefore"></slot>
    <slot v-if="getView === 'changePasswordSuccess'" name="successMessage">
      <div class="label msg-succeeded col-12">Dein Kennwort wurde erfolgreich geändert.</div>
    </slot>
    <slot v-if="getView === 'changePasswordView' || getView === 'changePasswordSuccess'" name="viewPasswordTxt">
      <div class="label col-12">Hier kannst du dein FYVE Passwort ändern.</div>
    </slot>
    <PasswordInput
      v-if="getView === 'changePasswordInput'"
    >
      <template v-for="slot in possibleChildSlotsFor('Input')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PasswordInput>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import slotProxy from '../../../../../../mixins/slotProxy'
import { mapMutations, mapGetters } from 'vuex'
import PasswordInput from './Input.vue'

export default {
  name: 'ChangePasswordWrapper',
  components: {
    PasswordInput
  },
  mixins: [
    slotProxy()
  ],
  created () {
    this.changeToViewStep()
  },
  computed: {
    ...mapGetters('changePassword', [
      'getView'
    ])
  },
  methods: {
    ...mapMutations('changePassword', [
      'changeStep',
      'changeToInputView',
      'changeToView'
    ]),
    changeToViewStep () {
      this.changeToView()
    }
  }
}
</script>
